export default __webpack_public_path__ + "static/media/gal7.78b744d8.jpg";